<div>
    <button mat-icon-button class="exitButton" (click)="close()"><mat-icon>close</mat-icon></button>
    <div (click)="clicked()">
        <h4>{{heading}}</h4>
        <p>{{description}}</p>
    </div>
</div>